<div class="tabs-scroll d-flex flex-column">
  @if(showTabs){
  <app-tab
    [tabs]="tabs"
    (tabSelected)="onTabChange($event)"
    [vScroll]="false"
    [hScroll]="true"
    class="w-100 d-flex justify-content-center pt-3 tabs-container"
    [selectedIndex]="selectedTabIndex"
  >
    <ng-template #tabLabel let-tab>
      <div class="tab-label-container m-auto">
        <span class="fs-14">{{ tab.label }}</span>
        <!-- Use label instead of name -->
      </div>
    </ng-template>
  </app-tab>
  }
  <!-- Conditionally load components based on the selected tab -->
  <div class="tab-content p-4 pt-0">
    <ng-container>
      <div
        class="d-flex align-items-center justify-content-center flex-column"
        [ngClass]="{ 'd-none': selectedTab !== 'fixed' }"
      >
        <app-dual-calendar
          [calendarMode]="viewMode"
          [minDate]="today"
          (dateRangeSelected)="onDateRangeChange($event)"
        >
        </app-dual-calendar>
      </div>
    </ng-container>

    <ng-container>
      <div
        class="mt-0 d-flex flex-column align-items-center"
        [ngClass]="{ 'd-none': selectedTab !== 'flexible' }"
      >
        <p class="fs-14 text-center mb-2 mt-4 styled-text">
          When do you want to go?
        </p>
        <div class="month-cards d-flex gap-2 mb-0 position-relative">
          @for (month of months; track $index) {
          <div
            class="month-section position-relative"
            (click)="selectMonth(month.name)"
            [ngClass]="{
              selected: selectedMonth == month.name,
              disabled: month.disabled,
            }"
            style="cursor: pointer"
          >
            <img
              class="cal-icon"
              src="assets/images/icons/calender.svg"
              alt="icon"
            />
            <div class="month-card fs-12">{{ month.name }}</div>

            @if(selectedMonth == month.name) {
            <img
              class="checked-icon"
              src="assets/images/icons/checked-icon.svg"
              alt="icon"
            />
            }
          </div>
          }
        </div>

        <hr class="solid" style="opacity: 0.15" />

        <p class="fs-14 text-center mb-2 styled-text">
          Which week do you want to go?
        </p>
        <div class="week-buttons mb-2">
          <button
            *ngFor="let week of weeks"
            (click)="selectWeek(week.name)"
            class="fs-12 me-2 position-relative"
            [ngClass]="{
              selected: selectedWeek == week.name,
              disabled: week.disabled
            }"
            [disabled]="week.disabled"
          >
            {{ week.name }}

            @if(selectedWeek == week.name) {
            <img
              class="checked-icon"
              src="assets/images/icons/checked-icon.svg"
              alt="icon"
            />
            }
          </button>
        </div>
      </div>
    </ng-container>

    <div
      class="w-100 d-flex justify-content-center apply-button-container mt-3"
    >
      <app-button
        type="primary"
        class="slim fs-14"
        (click)="applySelectedFilters()"
        [ngClass]="{ 'w-100': txlButtonWidth }"
        [disabled]="isApplyDisabled()"
        [title]="
          isApplyDisabled() ? 'Please select the departure week and month' : ''
        "
        >Apply</app-button
      >
    </div>
  </div>
</div>
